import { combineReducers } from 'redux'
import log from 'loglevel';

function defaultState(state = { }, action) {

	log.debug("Action: " + action);
	log.debug(state);

	return state
}

const rootReducer = combineReducers({
  defaultState,
})

export default rootReducer


// WEBPACK FOOTER //
// ./src/reducers/reducers.js